<ng-template #content let-modal>
  <div *ngIf="title" class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modalService.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="message" class="modal-body">
    <form>
      <div class="form-group text-center">
        <p>
          {{ message | translate }}
        </p>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark mx-auto" (click)="modalService.close('OK click')">OK</button>
  </div>
</ng-template>
<ng-container *ngTemplateOutlet="content"></ng-container>
